import React, { useContext, useState } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal';

import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable';
import { useNavigate } from 'react-router-dom';

import { DrgEnvioInterface } from '../../../ImportBackend/Interfaces/DrgInterfaces';
import BackEndAPI from '../../../Services/BackEndAPI';
import { MensagemTipo } from '../../../GlobalStates/MensagemState';
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces';
import { DateTime } from 'luxon';
import { DTFORMAT } from '../../../Utils/ClsFormatacao';
import ClsValidacao from '../../../Utils/ClsValidacao';

import { Box, Button, Container, Grid, IconButton, Paper, Tab, Tabs, Typography } from '@mui/material'

import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import InputText from '../../../DevComponents/InputText'
import Condicional from '../../../Layout/Condicional'
import ModalComponent from '../../../DevComponents/ModalComponent';

import TextArea from '../../../DevComponents/TextArea';
import RadioButton from '../../../DevComponents/RadioButton';

export default function DRGEnvio() {

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { mensagemState, setMensagemState, loginState } = contexto

  const navigate = useNavigate()

  const ResetDados = {
    idCliente: loginState.idClienteAtual,
    data: DateTime.now().toFormat(DTFORMAT.BANCO),
    dataInicio: DateTime.now().toFormat(DTFORMAT.BANCO),
    dataTermino: DateTime.now().toFormat(DTFORMAT.BANCO),
    exibirApenasErros: true,
    tipo: 'Admissao'
  }

  const [dados, setDados] = useState<typeof ResetDados>({ ...ResetDados })
  const [erros, setErros] = useState({})

  const [rsLogs, setRsLogs] = useState<Array<DrgEnvioInterface>>([])

  const clsApi: BackEndAPI = new BackEndAPI()

  const validarDados = (): boolean => {

    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.eData('data', dados, erros, retorno)
    retorno = clsValidacao.naoVazio('idCliente', dados, erros, retorno)

    setErros(erros)

    return retorno

  }

  const onEnviarDRG = () => {

    if (validarDados()) {

      const mutation = `
        enviarDRG (tipo: "${dados.tipo}", data: "${dados.data}", idCliente: ${dados.idCliente}) {
          ok
          mensagem
        }
      `

      clsApi.mutation<RespostaPadraoInterface>(mutation, 'enviarDRG', 'Enviando DRG...', contexto).then(rs => {

        if (rs.ok) {

          setMensagemState({
            ...mensagemState,
            titulo: 'DRG enviado com sucesso!',
            exibir: true,
            mensagem: 'Verifique as críticas no LOG!.',
            tipo: MensagemTipo.Info,
            exibirBotao: true
          })

        } else {

          setMensagemState({
            ...mensagemState,
            titulo: 'DRG não enviado!',
            exibir: true,
            mensagem: rs.mensagem,
            tipo: MensagemTipo.Error,
            exibirBotao: true
          })

        }

      }).catch(() => {

        setMensagemState({
          ...mensagemState,
          titulo: 'Erro! Consulte Suporte!',
          exibir: true,
          mensagem: 'Erro ao enviar DRG!',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        })

      })

    }

  }

  const onExibirLogs = () => {

    if (validarDados()) {

      const query = `
        exibirLogs (dataInicio: "${dados.dataInicio}", dataTermino: "${dados.dataTermino}", idCliente: ${dados.idCliente}, exibirApenasErros: ${dados.exibirApenasErros}) {
          idDrgEnvio
          idCliente
          dataReferencia
          cdAtendimento
          erro
          mensagemErro
          xml
          updatedAt
        }
      `

      clsApi.query<Array<DrgEnvioInterface>>(query, 'exibirLogs', 'Exibir Logs DRG...', contexto).then(rsLogs => {

        setRsLogs(rsLogs)

      }).catch(() => {

        setMensagemState({
          ...mensagemState,
          titulo: 'Erro! Consulte Suporte!',
          exibir: true,
          mensagem: 'Erro ao exibir Logs DRG!',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        })

      })

    }

  }

  const [rsTab, setRsTab] = useState(0)

  const changeRsTab = (_event: React.SyntheticEvent, newValue: number) => {
    setRsTab(newValue)
  }

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      cabecalho: 'Data Referência',
      campo: 'dataReferencia',
      alinhamento: 'left',
      format: (v) => DateTime.fromISO(v).toFormat(DTFORMAT.USUARIO)

    },
    {
      cabecalho: 'Código Atendimento',
      campo: 'cdAtendimento',
      alinhamento: 'right'
    },
    {
      cabecalho: 'Erro',
      campo: 'erro',
      alinhamento: 'left',
      format: (v) => v ? 'Sim' : 'Não'
    },
    {
      cabecalho: 'Mensagem de Erro',
      campo: 'mensagemErro',
      alinhamento: 'left'
    },
    {
      cabecalho: 'Enviado em',
      campo: 'updatedAt',
      alinhamento: 'left',
      format: (v) => DateTime.fromISO(v).toFormat(DTFORMAT.USUARIO_DATETIME)
    }
  ]

  const [currentPageOptions, setCurrentPageOptions] = useState<{ page: number; rowsPerPage: number }>({ page: 0, rowsPerPage: 10 })

  const onChangeCurrentPageOptions = (options: { page: number; rowsPerPage: number }) => {
    setCurrentPageOptions(options)
  }

  const onRetransmitirDRG = (rsDrgEnvio: DrgEnvioInterface) => {

    const mutation = `
        enviarDRG (data: "${rsDrgEnvio.dataReferencia}", idCliente: ${rsDrgEnvio.idCliente}, cdAtendimento: "${rsDrgEnvio.cdAtendimento}") {
          ok
          mensagem
        }
      `

    clsApi.mutation<RespostaPadraoInterface>(mutation, 'enviarDRG', 'Enviando DRG...', contexto).then(rs => {

      if (rs.ok) {

        setMensagemState({
          ...mensagemState,
          titulo: 'DRG enviado com sucesso!',
          exibir: true,
          mensagem: 'Verifique as críticas no LOG!.',
          tipo: MensagemTipo.Info,
          exibirBotao: true
        })

      } else {

        setMensagemState({
          ...mensagemState,
          titulo: 'DRG não enviado!',
          exibir: true,
          mensagem: rs.mensagem,
          tipo: MensagemTipo.Error,
          exibirBotao: true
        })

      }

    }).catch(() => {

      setMensagemState({
        ...mensagemState,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao enviar DRG!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      })

    })
  }

  const onExibirXML = (rsDrgEnvio: DrgEnvioInterface) => {
    setExibirXML(rsDrgEnvio.xml)
  }

  const [exibirXML, setExibirXML] = useState('')

  return (

    <>

      <Container maxWidth="md" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>

          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>

              <Typography component="h5" variant="h5" align="left">
                Enviar DRG Brasil
                <Typography variant="body2" gutterBottom>
                  Envio e Visualização de LOGs
                </Typography>
              </Typography>

              <IconButton onClick={() => navigate('/')}>
                <CloseIcon />
              </IconButton>

            </Grid>

            <Grid item xs={12}>

              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={rsTab} onChange={changeRsTab} aria-label="drg envio tabs">
                  <Tab label="Envio" />
                  <Tab label="Logs" />
                </Tabs>
              </Box>

            </Grid>

            <Condicional condicao={rsTab === 0}>

              <Grid item xs={12} md={4} sx={{ mt: 3 }}>
                <InputText
                  dados={dados}
                  field='data'
                  label='Data de Referência'
                  setState={setDados}
                  erros={erros}
                  tipo='date'
                />
              </Grid>

              <Grid item xs={12} md={4} sx={{ mt: 3, pl: { md: 1 } }}>
                <RadioButton
                  campoDescricao='descricao'
                  campoID='id'
                  dados={dados}
                  field='tipo'
                  label='Tipo do DRG'
                  opcoes={[{ id: 'Admissao', descricao: 'Admissão' }, { id: 'Alta', descricao: 'Alta' }]}
                  setState={setDados}
                  erros={erros}
                />

              </Grid>

              <Grid item xs={12} md={4} sx={{ mt: 6, pl: { md: 1 }, textAlign: 'right' }} >
                <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => onEnviarDRG()}>Enviar</Button>
              </Grid>

            </Condicional>

            <Condicional condicao={rsTab === 1}>

              <Grid item xs={12} md={3} sx={{ mt: 3 }}>
                <InputText
                  dados={dados}
                  field='dataInicio'
                  label='Data de Início'
                  setState={setDados}
                  erros={erros}
                  tipo='date'
                />
              </Grid>

              <Grid item xs={12} md={3} sx={{ mt: 3, pl: { md: 1 } }}>
                <InputText
                  dados={dados}
                  field='dataTermino'
                  label='Data de Término'
                  setState={setDados}
                  erros={erros}
                  tipo='date'
                />
              </Grid>

              <Grid item xs={12} md={3} sx={{ mt: 7, pl: { md: 1 }, textAlign: 'center' }} >

                <InputText
                  dados={dados}
                  field='exibirApenasErros'
                  label='Exibir Apenas Erros'
                  setState={setDados}
                  erros={erros}
                  tipo='checkbox'
                />

              </Grid>

              <Grid item xs={12} md={3} sx={{ mt: 6, pl: { md: 1 }, textAlign: 'right' }} >
                <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => onExibirLogs()}>Exibir Logs</Button>
              </Grid>

              <Grid item xs={12} sx={{ mt: 3 }}>


                <DataTable<DrgEnvioInterface>
                  dados={rsLogs}
                  onChangeCurrentPageOptions={(rs) => onChangeCurrentPageOptions(rs)}
                  currentPageOptions={currentPageOptions}
                  cabecalho={Cabecalho} acoes={
                    [
                      { icone: 'visibility', toolTip: 'XML', onDisabled: (rs) => !rs.cdAtendimento.length, onAcionador: (rs) => onExibirXML(rs) },
                      { icone: 'send', toolTip: 'Retransmitir', onDisabled: (rs) => !rs.cdAtendimento.length, onAcionador: (rs) => onRetransmitirDRG(rs) }
                    ]
                  } />
              </Grid>

            </Condicional>

            <ModalComponent
              exibir={exibirXML.length > 0}
              setExibir={() => setExibirXML('')}
            >
              <Box sx={{ m: 2, p: 2, borderBottom: 1, borderColor: 'divider' }}>
                <TextArea
                  dados={{ dados: exibirXML }}
                  field='dados'
                  label='XML DRG'
                  disabled={true}
                  height='400px'
                />
              </Box>
            </ModalComponent>

          </Grid>
        </Paper>
      </Container>

    </>

  )
}